import { render, staticRenderFns } from "./PrivacyPolicyPage.vue?vue&type=template&id=76538e0c&scoped=true"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=76538e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76538e0c",
  null
  
)

export default component.exports